"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIMENSION_NAME = exports.METRIC_NAME = exports.METRIC_UNIT = exports.GQL_ERROR_TYPE = exports.ERROR_CONTEXT = void 0;
var ERROR_CONTEXT;
(function (ERROR_CONTEXT) {
    ERROR_CONTEXT["APPLICATION"] = "application";
    ERROR_CONTEXT["GQL"] = "gql";
    ERROR_CONTEXT["NETWORK"] = "network";
    ERROR_CONTEXT["REST"] = "rest";
})(ERROR_CONTEXT = exports.ERROR_CONTEXT || (exports.ERROR_CONTEXT = {}));
var GQL_ERROR_TYPE;
(function (GQL_ERROR_TYPE) {
    GQL_ERROR_TYPE["BAD_REQUEST"] = "BadRequestException";
})(GQL_ERROR_TYPE = exports.GQL_ERROR_TYPE || (exports.GQL_ERROR_TYPE = {}));
var METRIC_UNIT;
(function (METRIC_UNIT) {
    METRIC_UNIT["COUNT"] = "Count";
    METRIC_UNIT["MILLISECONDS"] = "Milliseconds";
    METRIC_UNIT["NONE"] = "None";
})(METRIC_UNIT = exports.METRIC_UNIT || (exports.METRIC_UNIT = {}));
var METRIC_NAME;
(function (METRIC_NAME) {
    METRIC_NAME["APP_MOUNT"] = "app.react.mount";
    METRIC_NAME["APP_ERROR_CAUGHT"] = "app.error.caught";
    METRIC_NAME["APP_WARN_CAUGHT"] = "app.warn.caught";
    METRIC_NAME["APP_ERROR_UNKNOWN"] = "app.error.unknown";
    METRIC_NAME["APP_WARN_UNKNOWN"] = "app.warn.unknown";
    METRIC_NAME["APP_ERROR_REACT"] = "app.error.react";
    METRIC_NAME["PAGE_REACT_MOUNT_TO_CRITICAL_FEATURE"] = "page.latency.react_mount_to_cf";
    METRIC_NAME["PAGE_NAV_START_TO_CRITICAL_FEATURE"] = "page.latency.nav_start_to_cf";
    METRIC_NAME["PAGE_MOUNT"] = "page.mount";
    METRIC_NAME["PAGE_PLACEMENT_MOUNT"] = "page.placement_mount";
    METRIC_NAME["GQL_COMPLETE"] = "gql.complete";
    METRIC_NAME["GQL_ERROR"] = "gql.error";
    METRIC_NAME["GQL_ERROR_4XX"] = "gql.error.4xx";
    METRIC_NAME["GQL_LATENCY"] = "gql.latency";
    METRIC_NAME["GQL_START"] = "gql.start";
    METRIC_NAME["REST_START"] = "rest.start";
    METRIC_NAME["REST_COMPLETE"] = "rest.complete";
    METRIC_NAME["REST_LATENCY"] = "rest.latency";
    METRIC_NAME["REST_ERROR"] = "rest.error";
    METRIC_NAME["REST_ERROR_4XX"] = "rest.error.4xx";
    METRIC_NAME["EVENT_CHANGE_DAYS_ON_FIND_SHIFTS"] = "event.latency.chg_days";
    METRIC_NAME["EVENT_CHANGE_MONTHS_DATE_PICKER_MONTHS"] = "event.latency.cal_change_mons";
    METRIC_NAME["DATA_ERROR_INVALID_SHIFT_INTERVAL"] = "data.error.invalid_shift_interval";
    METRIC_NAME["DATA_ERROR_SWAP_SHIFTS_FOR_DAY_EMPTY"] = "data.error.shifts_for_day_empty";
    METRIC_NAME["BI_LAND_ON_DASHBOARD"] = "bi.land_on_dashboard";
    METRIC_NAME["BI_CLICK_REWARD_ICON"] = "bi.click_reward_icon";
    METRIC_NAME["BI_ON_LOCATION_ELIGIBILITY"] = "bi.on_location_eligibility";
    METRIC_NAME["BI_SELECT_DATE"] = "bi.select_date";
    METRIC_NAME["BI_VIEW_SCHEDULED_SHIFT_DETAIL"] = "bi.view_scheduled_shift_detail";
    METRIC_NAME["BI_DROP_SHIFT"] = "bi.drop_shift";
    METRIC_NAME["BI_DROP_SHIFT_FAILURE"] = "bi_drop_shift_fail";
    METRIC_NAME["BI_NAVIGATE_TO_FIND_SHIFT_PAGE"] = "bi.go_to_find_shift_page";
    METRIC_NAME["BI_NAVIGATE_TO_SWAP_PAGE"] = "bi.go_to_swap_page";
    METRIC_NAME["BI_SELECT_DIFFERENT_DATE"] = "bi.select_diff_date";
    METRIC_NAME["BI_SINGLE_STEP_ADD_SHIFT"] = "bi.1_step_add_shift";
    METRIC_NAME["BI_TWO_STEP_ADD_SHIFT"] = "bi.2_step_add_shift";
    METRIC_NAME["BI_TWO_STEP_SHIFT_ADD_CONFIRMATION"] = "bi.2_step_shift_add_confirm";
    METRIC_NAME["BI_POP_OPEN_SHIFT_DETAIL"] = "bi.pop_open_shift_detail";
    METRIC_NAME["BI_SINGLE_STEP_ADD_SHIFT_VIA_DETAIL_PAGE"] = "bi.1_step_add_shift_via_detail";
    METRIC_NAME["BI_TWO_STEP_ADD_SHIFT_VIA_DETAIL_PAGE"] = "bi.2_step_add_shift_via_detail";
    METRIC_NAME["BI_TWO_STEP_SHIFT_ADD_CONFIRMATION_VIA_DETAIL_PAGE"] = "bi.2_step_s_add_confirm_via_detail";
    METRIC_NAME["BI_ADD_SHIFT_FAILURE"] = "bi.add_shift_fail";
    METRIC_NAME["BI_OPEN_FILTER_DRAWER"] = "bi.open_filter_drawer";
    METRIC_NAME["BI_UPDATE_SURGE_PAY_FILTER"] = "bi.update_surge_pay_filter";
    METRIC_NAME["BI_UPDATE_START_TIME_FILTER"] = "bi.update_start_time_filter";
    METRIC_NAME["BI_UPDATE_UNAVAILABILITY_FILTER"] = "bi.update_unavailability_filter";
    METRIC_NAME["BI_UPDATE_LOCATION_FILTER"] = "bi.update_location_filter";
    METRIC_NAME["BI_UPDATE_JOB_CATEGORY_FILTER"] = "bi.update.job.category_filter";
    METRIC_NAME["BI_CLOSE_FILTER_DRAWER"] = "bi.close_filter_drawer";
    METRIC_NAME["BI_RESET_FILTERS"] = "bi.reset_filters";
    METRIC_NAME["BI_UPDATE_FILTER"] = "bi.update_filter";
    METRIC_NAME["BI_NO_PENALTY_DROP_SHIFT"] = "bi.no_penalty_drop_shift";
    METRIC_NAME["BI_NO_PENALTY_SHIFT_DROP_CONFIRMATION"] = "bi.no_penalty_shift_drop_confirmed";
    METRIC_NAME["BI_ACCEPT_INSTANT_SWAP"] = "bi.accept_instant_swap";
    METRIC_NAME["BI_INSTANT_SWAP_SUCCESS"] = "bi.instant_swap_success";
    METRIC_NAME["BI_INSTANT_SWAP_FAILURE"] = "bi.instant_swap_fail";
    METRIC_NAME["BI_CREATE_SWAP_REQUEST"] = "bi.create_swap_request";
    METRIC_NAME["BI_SWAP_REQUEST_SUCCESS"] = "bi.swap_request_success";
    METRIC_NAME["BI_SWAP_REQUEST_FAILURE"] = "bi.swap_request_fail";
    METRIC_NAME["BI_CANCEL_SWAP"] = "bi.cancel_swap";
    METRIC_NAME["BI_CANCEL_SWAP_SUCCESS"] = "bi.cancel_swap_success";
    METRIC_NAME["BI_CANCEL_SWAP_FAILURE"] = "bi.cancel_swap_fail";
})(METRIC_NAME = exports.METRIC_NAME || (exports.METRIC_NAME = {}));
var DIMENSION_NAME;
(function (DIMENSION_NAME) {
    DIMENSION_NAME["PAGE_NAME"] = "PageName";
    DIMENSION_NAME["GQL_OPERATION_NAME"] = "GQLOperationName";
    DIMENSION_NAME["REST_OPERATION_NAME"] = "RestOperationName";
    DIMENSION_NAME["IS_GQL_INVOKED"] = "IsGqlInvoked";
})(DIMENSION_NAME = exports.DIMENSION_NAME || (exports.DIMENSION_NAME = {}));
